(function () {

    var LIST_AJAX_URL = '/story/library/livingList.lgajax';
    var DETAIL_VIEW_URL = '/story/library/living/';

    var listTemplate = '' +
        '{{#each (item, index) in list}}' +
        '    <li><a href="{{item.detailHref}}">{{#raw item.displayTitle}}</a></li>' +
        '{{/each}}';

    var storyLivingLibraryList = {
        init: function () {
            var self = this;
            var $paginationContainer = $('div.story-list-wrap .pagination');

            $paginationContainer.css('pointer-events', 'none');

            vcui.require(['ui/pagination'], function () {
                self.setting();
                self.bindEvents();
                $paginationContainer.css('pointer-events', 'auto');
            });
        },

        setting: function () {
            var self = this;
            var $contents = $('div.story-list-wrap');
            var $pagination = $contents.find('div.pagination');

            if ($pagination.length) {
                self.$pagination = $pagination.vcPagination();
            }
        },

        bindEvents: function () {
            var self = this;

            if (!self.$pagination) {
                return;
            }

            self.$pagination.on('page_click', function (e, page) {
                var urlParams = new URLSearchParams(window.location.search);
                urlParams.set('page', page);
                self.requestData(urlParams);
            });

            $(window).on('popstate', function () {
                var urlParams = new URLSearchParams(window.location.search);
                self.requestData(urlParams, true);
            });
        },

        requestData: function (urlParams, skipHistoryUpdate, isInitial) {
            var self = this;
            var $contents = $('div.story-list-wrap');
            var $itemList = $contents.find('ul.story-wiki-list.library');
            var $total = $itemList.siblings('div.total').find('strong');

            if (!skipHistoryUpdate) {
                var queryString = urlParams.toString();
                if (queryString !== '') {
                    history.pushState(null, '', window.location.pathname + '?' + queryString);
                }
            }

            var ajaxUrl = LIST_AJAX_URL + (urlParams.toString() ? '?' + urlParams.toString() : '');

            lgkorUI.requestAjaxData(ajaxUrl, null, function (result) {
                var responseParam = result.param;
                var data = result.data;

                var totalCnt = responseParam && responseParam.totalCnt != null ? responseParam.totalCnt : 0;
                $total.text(vcui.number.addComma(totalCnt));

                var listData = data && data instanceof Array ? data : [];
                $itemList.empty();

                if (listData.length > 0) {
                    if (totalCnt > 0 && responseParam && responseParam.pagination && self.$pagination) {
                        self.$pagination.vcPagination('setPageInfo', responseParam.pagination);
                        self.$pagination.show();
                    }
                    var querySuffix = window.location.search || '';
                    listData.forEach(function (item) {
                        item.detailHref = DETAIL_VIEW_URL + item.libraryId + querySuffix;
                    });
                    $itemList.html(vcui.template(listTemplate, { list: listData }));
                    $itemList.show();
                    if (!isInitial) {
                        $itemList.find('li:first a').focus();
                    }
                } else {
                    $itemList.hide();
                    if (self.$pagination) {
                        self.$pagination.hide();
                    }
                }
            }, 'GET', 'json', true, null, true, function () {
                $itemList.hide();
                if (self.$pagination) {
                    self.$pagination.hide();
                }
                void 0;
            });
        }
    };

    $(document).ready(function () {
        if ($('div.story-list-wrap ul.story-wiki-list.library').length) {
            storyLivingLibraryList.init();
        }
    });
})();
